module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA2CAYAAABnctHeAAAAm0lEQVRoge3asQ2AIBQAUTHOwv7rwDLaWKgUGhPF+95rjAkFFwp+QSqlzANDWr+n+x0f3kgXRlEYRWEURcioqfcGbkjbn5xzs8CT+ojdmFRrbRaEPCmjKIyiMIoiZBTx8nVMonBMCsMoCqMojKIgXr6OSRSOSWEYRWEUhVEU03AYOwD+OyZdeZt0+V3Q22sdk8iMojCKwiiKkFELge4ZB5qoIb8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/1+9.png
// module id = IQO+
// module chunks = 0